import { Component, HostListener } from '@angular/core';
import { DefaultHeaderComponent } from '../default-header/default-header.component';
import { PagesRoutingModule } from '../../pages/pages-routing.module';
import { DefaultSidebarComponent } from '../default-sidebar/default-sidebar.component';
import { DefaultFooterComponent } from '../default-footer/default-footer.component';

@Component({
  selector: 'app-default-body',
  imports: [DefaultHeaderComponent, PagesRoutingModule, DefaultSidebarComponent], //DefaultFooterComponent
  templateUrl: './default-body.component.html',
  styleUrl: './default-body.component.scss',
})
export class DefaultBodyComponent {
  isSidebarClosed = false;
  isMobile = false;

  constructor() {
    this.checkIfMobile();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkIfMobile();
  }

  checkIfMobile() {
    this.isMobile = window.innerWidth < 768; // Adjust breakpoint as needed
  }

  toggleSidebar() {
    this.isSidebarClosed = !this.isSidebarClosed;
  }
}
